import request from '@/utils/request'
export function login(data) {
  return request({
    url: '/api/demo/login',
    method: 'post',
    data
  })
}
export function getInfo(data) {
  return request({
    url: '/api/demo/get_info',
    method: 'post',
    data
  })
}
export function configs() {
  return request({
    url: '/api/demo/config',
    method: 'post'
  })
}
export function admin_login(data){
  return request({
    url: '/api/user/admin_login',
    method: 'post',
    data
  })
}
export function userinfo(data){
  return request({
    url: '/api/index/userinfo',
    method: 'post',
    data
  })
}
export function web_login(){
  return request({
    url: '/api/indexnew/web_login',
    method: 'post'
  })
}
export function checkStatus(data){
  return request({
    url: '/api/indexnew/checkStatus',
    method: 'post',
    data
  })
}
export function logout(data){
  return request({
    url: '/api/indexnew/logout',
    method: 'post',
    data
  })
}

export function getlinks(data){
  return request({
    url: '/api/demo/links',
    method: 'post',
    data
  })
}

 
export function getservicelist(data){
  return request({
    url: '/api/demo/servicelist',
    method: 'post',
    data
  })
}

export default {
	login,
  getInfo,
  logout,
  configs,
  admin_login,
  web_login,
  checkStatus,
  userinfo,
  getlinks,
  getservicelist
}



// WEBPACK FOOTER //
// ./src/api/user.js